<script>
export default {
}
</script>

<template>
  <router-view />
</template>
